import './MembershipReward.css';

export const MembershipReward = (props: { icon: string; name: string; description?: string; absolute?: boolean; disabled?: boolean }) => {
   return (
      <div className={`membership-reward ${props.absolute ? 'absolute' : ''} flex gap-2 items-center justify-between ${props.disabled ? 'disabled' : ''}`}>
         <img
            src={props.icon}
            alt=""
            width={52}
            height={42}
         />
         <div className="flex flex-col gap-1">
            <span>{props.name}</span>
            <span className="small ">{props.description ?? '1 free month'}</span>
         </div>
      </div>
   );
};
